import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGiftCard } from "src/models/Prices/GiftCard.models";

interface GiftCardState {
  giftCards: IGiftCard[];
  giftCardToEdit: IGiftCard | null;
}

const initialState: GiftCardState = {
  giftCards: [],
  giftCardToEdit: null,
};

const GiftCardSlice = createSlice({
  name: "GiftCard",
  initialState,
  reducers: {
    setGiftCardList: (state, action: PayloadAction<IGiftCard[]>) => {
      state.giftCards = action.payload;
    },
    setGiftCardToEdit: (state, action: PayloadAction<IGiftCard | null>) => {
      state.giftCardToEdit = action.payload;
    },
    concatListGiftCard: (
      state: GiftCardState,
      action: PayloadAction<IGiftCard[]>
    ) => {
      state.giftCards = [...state.giftCards.concat(action.payload)];
    },
    addGiftCard: (state, action: PayloadAction<IGiftCard>) => {
      state.giftCards.push(action.payload);
    },
    updateGiftCard: (state, action: PayloadAction<IGiftCard>) => {
      let itemIndex = state.giftCards.findIndex(
        item => item.giftCardId === action.payload.giftCardId
      );
      if (itemIndex !== -1) state.giftCards[itemIndex] = action.payload;
    },
    deleteGiftCard: (state, action: PayloadAction<number>) => {
      const newArray = state.giftCards.filter(
        item => item.giftCardId !== action.payload
      );
      state.giftCards = newArray;
    },
  },
});

export const {
  setGiftCardList,
  concatListGiftCard,
  setGiftCardToEdit,
  addGiftCard,
  updateGiftCard,
  deleteGiftCard,
} = GiftCardSlice.actions;

export default GiftCardSlice.reducer;
